export const howSectionData = {
	largeCard: [
		{
			id: 0,
			title: "Explore Our Categories and Find Inspiring Articles",
			description:
				"Read Personal Stories of Transformation and Resilience. Dive into a world of motivating and insightful articles that cover a wide range of topics. From personal growth and overcoming challenges to celebrating small victories, our collection of stories is designed to inspire and empower you on your journey.",
			buttons: { first: "Get Started", second: "Join Now" },
			image: {
				src: "/images/howSectionImages/explore.jpg",
				alt: "Explore Categories",
			},
		},
		{
			id: 1,
			title: "Join Our Community and Share Your Journey",
			description:
				"Connect with Like-Minded Individuals and Support Each Other. Our community is a safe space where you can share your experiences, seek advice, and find encouragement from people who understand your journey. Join the conversation, make new friends, and build a support network that helps you thrive.",
			buttons: { first: "Get Involved", second: "Join The Conversation" },
			image: {
				src: "/images/howSectionImages/community.jpg",
				alt: "Join Community",
			},
		},
	],
	mediumCard: [
		{
			id: 2,
			title: "Nutrition Advice",
			description:
				"Find the Information You Need. Our comprehensive guides and expert tips will help you navigate the world of nutrition with ease. Whether you're looking to improve your diet, understand nutritional labels, or find healthy recipes, we've got you covered with reliable and practical advice.",
			buttons: { first: "Explore" },
			image: {
				src: "/images/howSectionImages/nutri.png",
				alt: "Nutrition Advice",
			},
		},
	],
	smallCard: [
		{
			id: 3,
			title: "Mental Health",
			description:
				"Learn from Experts in the Field. Discover valuable insights and strategies to maintain and improve your mental well-being. Our articles feature advice from psychologists, therapists, and mental health professionals who share their knowledge on coping mechanisms, stress management, and building resilience.",
			buttons: { first: "Join" },
		},
		{
			id: 4,
			title: "Fitness Tips",
			description:
				"Become Part of Our Community. Stay active and healthy with our fitness tips that cater to all levels of experience. From workout routines and exercise techniques to motivational stories and fitness challenges, our content is designed to help you achieve your fitness goals and maintain a healthy lifestyle.",
			buttons: { first: "Sign Up" },
		},
	],
};
